module.exports = __webpack_public_path__ + "static/media/mn11.6b89bd35.jpeg";